import * as React from "react";
import {Filter, FilterChangesCallback} from "./App";
import {GeoProps} from "../services/SearchService";
interface Props {
	filters: Map<Filter, Set<string>>;
    geo: GeoProps
	onFilterChange?: FilterChangesCallback;
    onDeleteLocation: () => void
}

export default function ActiveFilters(props: Props) {

	const activeFilters: any = [];
	props.filters.forEach((values, filter) => {
		values.forEach(value => {
			activeFilters.push({
				value,
				filter
			});
		});
	})

	const resetAll = function () {
		activeFilters.forEach((activeFilter:any) => {
            if (activeFilter.filter.id !== 'district'){
                props.onFilterChange(activeFilter.value, activeFilter.filter);
            }
		});
        props.onDeleteLocation();
	}

	return (
		<div className={`active-filters d-flex mb-5`}>
			<ul className={"p-0 m-0 d-flex"}>
				{activeFilters.map((activeFilter: any) => {
                    return (<li className={"me-3 "}><button key={activeFilter.filter.id+'|'+activeFilter.value} onClick={() => props.onFilterChange(activeFilter.value, activeFilter.filter)}>{activeFilter.value}</button></li>)
				})}
                {props.geo.lng !== undefined && props.geo.lat !== undefined && <li className={"me-3"}><button onClick={() => props.onDeleteLocation()}>Umkreis</button></li>}
			</ul>

			<button className="filter-button-reset" onClick={resetAll}>Alle Filter zurücksetzen</button>
		</div>
	);
}
